import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import AlertTemplate, { AlertTypes } from '@components/Alert/Alert';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import LecturerTemplate from '@components/Lecturer/Lecturer';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import { IS_PROD } from '../../constants';
import { ILecturerItem } from '../../interfaces/Lecturer';
import { lecturerApi } from '../../services/lecturer.service';

interface ILecturer {
    status: number;
    lecturer?: ILecturerItem;
}

const Lecturer: NextPage<ILecturer> = (props) => {
    const { t } = useTranslation();

    if (props?.status && props?.status !== 200) return <AlertTemplate type={AlertTypes.error} />;

    return (
        <>
            <NextSeo title={t('seo.page.common')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <ContentTemplate withPadding mobileSidePadding={20}>
                <LecturerTemplate lecturer={props?.lecturer} />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

Lecturer.getInitialProps = async (ctx) => {
    try {
        const { data } = await lecturerApi.detail(ctx.query.slug as string);

        return {
            status: 200,
            lecturer: data,
        };
    } catch {
        return {
            status: 500,
        };
    }
};

export default Lecturer;
